// Stessa corrispondenza usata lato server in Permissions.GetPermissionsForRole
// (DomusAurea-Shared/Authorization/Permissions.cs): un dipendente creato come
// Titolare/Responsabile/Back Office ha il ruolo Identity letterale
// "AgencyOwner"/"BranchManager"/"BackOffice" (non "Admin"/"Manager"), ma con
// permessi equivalenti - ogni check "è admin/manager" nel frontend deve
// seguire la stessa mappatura, altrimenti risulta false per un Titolare pur
// avendo lui permessi pieni. Fonte unica per evitare che i due concetti
// (ruolo Identity letterale vs livello di permessi) divergano di nuovo.
const ADMIN_TIER_ROLES = new Set(['Admin', 'AgencyOwner'])
const MANAGER_TIER_ROLES = new Set(['Admin', 'AgencyOwner', 'Manager', 'BranchManager', 'BackOffice'])

export const ROLE_LABELS: Record<string, string> = {
  Admin: 'Amministratore',
  Manager: 'Manager',
  Agent: 'Agente',
  AgencyOwner: 'Titolare',
  BranchManager: 'Responsabile',
  BackOffice: 'Back Office',
  LimitedUser: 'Utente Limitato',
}

export function isAdminTierRole(role: string | null | undefined): boolean {
  return !!role && ADMIN_TIER_ROLES.has(role)
}

export function isManagerTierRole(role: string | null | undefined): boolean {
  return !!role && MANAGER_TIER_ROLES.has(role)
}

export function getRoleLabel(role: string | null | undefined): string {
  return (role && ROLE_LABELS[role]) || 'Agente'
}
